module.exports = __webpack_public_path__ + "static/media/sell_individual_plan.d50dc7ed.jpg";